import React from "react";
import { Icon } from "~assets/frontend/elements/icon/Icon";
import { getId } from "~assets/frontend/_util/getId";
export const Indicators = ({ length, activeIndicator, className }) => {
    return (React.createElement("div", { className: "flex gap-12 " + className }, [...Array(length)].map((indicator, index) => {
        return (React.createElement(Icon, { _id: getId(), _name: "IconStruct", key: index, className: "before:h-24 before:w-24 before:bg-black-100 dark:before:bg-white", identifier: index === activeIndicator ? "icon-indicator-circle" : "icon-indicator-dot" }));
    })));
};
